module.exports = __webpack_public_path__ + "media/images/icons/pictures-f179834daf4db12890650869e0580aef.gif";